import React, { useMemo } from 'react'
import { Text, Flex } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { QuestCategory } from 'state/vvsgotchi/models'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { questCategoryDetails } from 'views/VvsGotchi/config'

import { CategoryBg } from './styles'

const Category = ({
  category,
  children,
}: {
  category: Exclude<QuestCategory, QuestCategory.ONBOARDING>
  children: React.ReactNode
}) => {
  const { t } = useTranslation()
  const { title, description, bannerImageUrl, bgImageUrl } = useMemo(() => {
    const details = questCategoryDetails[category]
    if (!details)
      return {
        title: null,
        description: null,
        bannerImageUrl: null,
        bgImageUrl: null,
      }
    return {
      ...details,
      title: details.title(t),
      description: details.description(t),
    }
  }, [category, t])

  return (
    <CategoryBg bg={bgImageUrl}>
      <Flex px={3} pt={4}>
        <Flex flexDirection="column" flex="1">
          <Text color="black" fontSize="20px" bold as="h3">
            {title}
          </Text>
          <Text color="black" width={bannerImageUrl ? '188px' : undefined} fontSize="13px">
            {description}
          </Text>
        </Flex>
        {bannerImageUrl && <PixelatedImage src={bannerImageUrl} alt={title} height="72px" whenRetina />}
      </Flex>
      {children}
    </CategoryBg>
  )
}

export default Category
